export default "__VITE_ASSET__f8ec5232__"